import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Sidebar from './Sidebar'

import { actionCreators as cacheActionCreators } from '@/checkout-instore-legacy/cache/actions'
import { actionCreators as vendorActionCreators } from '@/checkout-instore-legacy/vendor/actions'
import { vendorSelector } from '@/checkout-instore-legacy/vendor/selectors'

const mapStateToProps = (state) => ({
  vendor: vendorSelector(state),
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { ...vendorActionCreators, ...cacheActionCreators },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar)
